import { append } from './append';
import { read } from './read';

export const relayState = {
  append,
  read,
};
